export enum BankMatchesSortProperty {
  SideAmount = 'sideAmount',
  EntryDate = 'entryDate',
}
